import {
  normalizeModuleKey,
  normalizeModuleKeys,
  type PermissionsMap,
  type PermissionActionKey,
} from 'src/pages/auth/hooks/permission-utils';

export type { PermissionsMap, PermissionActionKey };

const SUPER_ADMIN = 'Super Admin';

export function isSuperAdminRole(role: string | null | undefined): boolean {
  return role === SUPER_ADMIN;
}

export function isManagementRole(role: string | null | undefined): boolean {
  return role?.toLowerCase() === 'management';
}

export function checkHasPermission(
  permissions: PermissionsMap | null,
  userRole: string | null | undefined,
  module: string | string[]
): boolean {

  const check = (m: string) => {
    const key = normalizeModuleKey(m);
    if (key === 'csat_analytics') {
      return !!permissions?.csat?.view;
    }
    if (key === 'csat_config') {
      return !!permissions?.csat?.manage;
    }
    if (key === 'setting') {
      return true;
    }
    if (key === 'bill' || key === 'billing') {
      return !!permissions?.billing?.view || !!permissions?.bill?.view;
    }
 
    return !!permissions?.[key]?.view;
  };

  if (Array.isArray(module)) {
    return normalizeModuleKeys(module).some(check);
  }
  return check(module);
}

export function checkHasModuleAction(
  permissions: PermissionsMap | null,
  userRole: string | null | undefined,
  moduleName: string | string[],
  actionType: PermissionActionKey | string
): boolean {
  const action = actionType as PermissionActionKey;

  const check = (m: string) => {
    const key = normalizeModuleKey(m);
    return !!permissions?.[key]?.[action];
  };

  if (Array.isArray(moduleName)) {
    return normalizeModuleKeys(moduleName).some(check);
  }
  return check(moduleName);
}

export function createPermissionCheckers(permissions: PermissionsMap | null, userRole: string | null) {
  return {
    hasPermission: (module: string | string[]) =>
      checkHasPermission(permissions, userRole, module),
    hasModuleActionPermission: (
      moduleName: string | string[],
      actionType: PermissionActionKey | string
    ) => checkHasModuleAction(permissions, userRole, moduleName, actionType),
  };
}
